import React from "react";

/**
 * ErrorBoundary
 *
 * CRA/React runtime errors can otherwise lead to a blank screen in production.
 * This boundary renders a minimal fallback and logs the real error to console.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI crashed:", error, info);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;

    const message =
      this.state.error?.message || "Erro inesperado ao renderizar esta página.";

    return (
      <div
        style={{
          minHeight: "100dvh",
          padding: 24,
          fontFamily:
            "ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial",
          background: "#fff",
          color: "#111",
        }}
      >
        <h1 style={{ margin: "0 0 12px", fontSize: 20 }}>
          Erro ao carregar a página
        </h1>
        <p style={{ margin: "0 0 16px", lineHeight: 1.5 }}>{message}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: "10px 14px",
            border: "1px solid #111",
            background: "#111",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Recarregar
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
